import React, { forwardRef, useEffect, useRef } from 'react';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { useAppContext } from 'providers/AppProvider';

const ReactEchart = forwardRef(({ ...rest }, ref) => {
  const innerRef = useRef(null);
  const chartRef = ref || innerRef;
  const containerRef = useRef(null);
  const {
    config: { isFluid, isNavbarVerticalCollapsed }
  } = useAppContext();

  const safeResize = () => {
    try {
      const inst = chartRef.current?.getEchartsInstance?.();
      if (inst) inst.resize();
      else chartRef.current?.resize?.();
    } catch (_) {
      // ignore resize errors during unmount / StrictMode double-invoke
    }
  };

  useEffect(() => {
    if (chartRef.current) {
      safeResize();
    }
  }, [isFluid, isNavbarVerticalCollapsed]);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return undefined;

    let ro;
    if (typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(() => safeResize());
      ro.observe(el);
    }

    const onWindowResize = () => safeResize();
    window.addEventListener('resize', onWindowResize);

    return () => {
      window.removeEventListener('resize', onWindowResize);
      ro?.disconnect?.();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div ref={containerRef}>
      <ReactEChartsCore ref={chartRef} autoResize={false} {...rest} />
    </div>
  );
});

export default ReactEchart;
